<template>
  <div class="my-order">
    <el-menu
      router
      :default-active="currentMenu"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#fff"
      text-color="#333333"
      active-text-color="#2782EC"
      @select="handleSelect"
    >
      <el-menu-item index="0" route="/fusePurchaseRequest">
        <span>采购申请</span>
      </el-menu-item>
      <el-menu-item index="1" route="/fusePurchaseRequest">
        <span>采购申请跟踪</span>
      </el-menu-item>
    </el-menu>
    <!-- <nuxt-child /> -->
  </div>
</template>

<script>
export default {
  props: {
    currentMenu: String,
    setCurrentMenu: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      activeIndex2: '0',
      countOrder: {},
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex2 = key;
      this.setCurrentMenu(key);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
.my-order {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  ul {
    li {
      border-bottom-color: $border-color !important;
    }
  }
  ::v-deep.el-menu--horizontal > .el-menu-item {
    height: 40px;
    line-height: 32px;
    width: 166px;
    text-align: center;
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    border-top: 2px solid transparent;
    &:last-child {
      width: 168px;
    }
  }

  ::v-deep .el-menu--horizontal > .el-menu-item:hover {
    background: #f4f7ff !important;
  }

  ::v-deep .el-menu--horizontal > .is-active {
    background: #f4f7ff !important;
    border-top: 2px solid #0064c8;
    border-bottom: none;
  }
  ::v-deep .el-menu--horizontal {
    border-bottom: none;
  }
  ::v-deep .el-menu-demo {
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;
    border-left: 1px solid $border-color;
    display: flex;
  }
  ::v-deep.el-badge__content {
    line-height: 15px;
    border-color: #f56c6c;
  }

  ::v-deep .el-badge__content.is-fixed {
    top: 8px;
    right: 0;
  }

  ::v-deep .el-menu--horizontal > .el-menu-item {
    border-bottom: none;
  }
  ::v-deep .el-menu--horizontal > .el-menu-item:last-child {
    border-right: none;
  }
}
</style>
